<template>
  <div class="brand-settings-page">
    <header>
      <div class="brand-header-left">
        <i class="fa-solid fa-chevron-left" @click="$router.back()" style="cursor: pointer;"></i>
        <span style="margin-left:auto; margin-right:auto;">브랜드관 설정</span>
      </div>
      <div class="brand-header-right">
        <!-- 공유 링크 메뉴가 없는 직원에게는 숨김(누르면 「권한 없음」으로 튕김 — 라우터와 같은 판정) -->
        <a-button v-if="canOpenShareLinks" @click="$router.push('/share-links')">링크 관리</a-button>
        <a-button @click="copyBrandPreviewLink">링크 복사</a-button>
        <a-button type="primary" @click="saveBrandSettings">저장하기</a-button>
      </div>
    </header>
    <main>
      <div class="brand-settings-container">
        <div class="brand-preview-section" ref="previewSection">
          <div class="brand-preview-section__inner" ref="previewInner">
            <!-- 헤더 영역 (배경, 로고, 브랜드명, 버튼) - 고정 위치 -->
            <div class="brand-preview-section__inner__content" data-section-key="header" :ref="setItemRef" style="padding: 0;">
              <img :src="mainBg.fileList[0]?.url || defaultImage" class="main-bg" :style="!mainBg.fileList[0]?.url ? 'border:2px solid #EBEBEB;' : ''"/>
              <div class="brand-header" style="padding: 20px;">
                <img :src="brandLogo.fileList[0]?.url || defaultImage" class="brand-logo" :style="!brandLogo.fileList[0]?.url ? 'border:2px solid #EBEBEB;' : ''"/>
                <h1 class="brand-name">{{brandName}}</h1>
                <p class="brand-address">{{ companyAddress }}</p>
                <a-button :style="{backgroundColor: mainButton.hexColor}" @click="openLink(mainButton.link)">{{mainButton.text}}</a-button>
              </div>
            </div>
            
            <!-- 섹션 순서대로 동적 렌더링 -->
            <template v-for="sectionKey in sectionOrder" :key="sectionKey">
              <!-- couponList: 쿠폰함 -->
              <div
                v-if="sectionKey === 'couponList'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px; width:100%; overflow-x: auto; display: flex; flex-direction: column; flex:none;"
                v-show="couponList.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{ couponList.title }}
                  <a href="#" class="view-more">더보기 ></a>
                </div>
                <div class="coupon-list">
                  <div
                    class="coupon-item clickable-section"
                    v-for="(item, index) in couponList.items"
                    :key="`coupon-${index}`"
                    @click="openLink(item.link)"
                  >
                    <div class="coupon-item__inner">
                      <img :src="item.fileList[0]?.url || defaultImage" alt="쿠폰 이미지"/>
                    </div>
                    <p class="coupon-item__title" v-if="item.title">{{ item.title }}</p>
                  </div>
                </div>
              </div>

              <!-- certificateList: 내 인증서 보기 -->
              <div
                v-if="sectionKey === 'certificateList'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px; width:100%; overflow-x: auto; display: flex; flex-direction: column; flex:none;"
                v-show="certificateList.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{ certificateList.title }}
                  <a href="#" class="view-more">더보기 ></a>
                </div>
                <div class="certificates">
                  <div
                    class="certificate clickable-section"
                    v-for="(item, index) in certificateList.items"
                    :key="`certificate-${index}`"
                    @click="openLink(item.link)"
                  >
                    <div class="certificate__inner">
                      <img :src="item.fileList[0]?.url || defaultImage" alt="인증서 이미지" />
                    </div>
                    <p class="certificate__title" v-if="item.title">{{ item.title }}</p>
                    <p class="certificate__date" v-if="item.date">{{ item.date }}</p>
                  </div>
                </div>
              </div>

              <!-- imageList: 브랜드 소식 (이미지 - 가로 스크롤) -->
              <div
                v-else-if="sectionKey === 'imageList'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px;"
                v-show="imageList.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{imageList.title}}
                  <a href="#" class="view-more">더보기 ></a>
                </div>
                <div class="image-list">
                  <div class="image-list__item clickable-section" v-for="(item,index) in imageList.items" :key="`image-${index}`"
                  @click="openLink(item.link)">
                    <img :src="item.fileList[0]?.url || defaultImage" alt="이미지"/>
                    <div class="image-list__item__content">
                      <p class="image-list__item__title">{{ item.title || '제목' }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- bigImageList: 이벤트 (큰 이미지) -->
              <div
                v-else-if="sectionKey === 'bigImageList'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px;"
                v-show="bigImageList.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{bigImageList.title}}
                  <a href="#" class="view-more">더보기 ></a>
                </div>
                <div class="big-image-list clickable-section" v-for="(item,index) in bigImageList.items" :key="`big-image-${index}`"
                @click="openLink(item.link)">
                  <img :src="item.fileList[0]?.url || defaultImage" alt="이벤트 이미지" style="border:1px solid #EBEBEB; border-radius: 10px; width: 100%; height: 140px; object-fit: cover;"/>
                  <div class="label-text big-size ellipsis-text">
                    {{ item.title || '제목을 입력해주세요' }}
                  </div>
                  <div class="sub-text" v-if="item.description" style="white-space: pre-line;">
                    {{ item.description }}
                  </div>
                  <div class="sub-text" v-if="item.date">
                    {{ item.date }}
                  </div>
                </div>
              </div>

              <!-- imageNewsList: 자이스 스마일 알아보기 -->
              <div
                v-else-if="sectionKey === 'imageNewsList'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px;"
                v-show="imageNewsList.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{imageNewsList.title}}
                  <a href="#" class="view-more">더보기 ></a>
                </div>
                <div class="smile-card-list">
                  <div class="smile-card-list__item clickable-section" v-for="(item,index) in imageNewsList.items" :key="`smile-card-${index}`"
                    @click="openLink(item.link)">
                    <img :src="item.fileList[0]?.url||defaultImage" alt="인증서 이미지" />
                    <div class="smile-card-list__item__content" style="width: calc(100% - 60px);">
                      <p class="smile-card-list__item__title ellipsis-text">{{ item.title||'제목을 입력해주세요' }}</p>
                      <p class="smile-card-list__item__description ellipsis-text">{{ item.description||'설명을 입력해주세요' }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- cardList: 스마일 카드 알아보기 -->
              <div
                v-else-if="sectionKey === 'cardList'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px;"
                v-show="cardList.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{cardList.title}}
                  <a href="#" class="view-more">더보기 ></a>
                </div>
                <div class="smile-card-list">
                  <div class="smile-card-list__item clickable-section" v-for="(item,index) in cardList.items" :key="index" @click="openLink(item.link)">
                    <div class="smile-card-list__item__content">
                      <p class="smile-card-list__item__title ellipsis-text">{{ item.title || '제목을 입력해주세요' }}</p>
                      <p class="smile-card-list__item__description ellipsis-multiline">{{ item.description || '설명을 입력해주세요' }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- newsList: 보도자료 -->
              <div
                v-else-if="sectionKey === 'newsList'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px;"
                v-show="newsList.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{newsList.title}}
                  <a href="#" class="view-more">더보기 ></a>
                </div>
                <div class="news-list">
                  <div class="news-list__item clickable-section" v-for="(item,index) in newsList.items" :key="index" @click="openLink(item.link)">
                    <div class="news-list__item__content">
                      <p class="news-list__item__title ellipsis-text">{{ item.title || '제목을 입력해주세요' }}</p>
                      <p class="news-list__item__description ellipsis-multiline">{{ item.description || '설명을 입력해주세요' }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- officialChannels: 공식 채널 -->
              <div
                v-else-if="sectionKey === 'officialChannels'"
                class="brand-preview-section__inner__content"
                style="padding: 0px 20px 20px 20px;"
                v-show="officialChannels.isShow"
                :ref="setItemRef"
                :data-section-key="sectionKey"
              >
                <div class="label-text big-size">
                  {{officialChannels.title}}
                </div>
                <div class="channel-list">
                  <div class="channel-wrap clickable-section" v-for="(item,index) in officialChannels.items" :key="index" @click="openLink(item.link)" v-show="item.isShow !== false">
                    <img :src="item.fileList[0]?.url || item.defaultImage || defaultImage" alt="이미지" :style="!(item.fileList[0]?.url || item.defaultImage) ? 'border:2px solid #EBEBEB; border-radius: 50%;' : ''"/>
                    <div class="channel-name">{{item.title || '채널명'}}</div>
                  </div>
                </div>
              </div>

              <!-- customSection-*: 개별 추가 섹션 -->
              <template v-else-if="isCustomSectionKey(sectionKey)">
                <div class="brand-preview-section__inner__content" style="padding: 0px 20px 20px 20px;" v-if="getCustomSectionById(sectionKey)" v-show="getCustomSectionById(sectionKey).isShow" :data-section-key="sectionKey" :ref="setItemRef">
                  <div class="label-text big-size">
                    {{getCustomSectionById(sectionKey).title}}
                    <a href="#" class="view-more">더보기 ></a>
                  </div>
                  <!-- big-image-list 타입: 고정 섹션과 동일한 스타일 -->
                  <div v-if="getCustomSectionById(sectionKey).type === 'big-image-list'" class="big-image-list">
                    <div class="big-image-list clickable-section"
                      v-for="(item,itemIndex) in getCustomSectionById(sectionKey).items"
                      :key="`custom-section-${sectionKey}-${itemIndex}`"
                      @click="openLink(item.link)">
                      <img :src="item.fileList[0]?.url || defaultImage" alt="이미지" style="border:1px solid #EBEBEB; border-radius: 10px; width: 100%; height: 140px; object-fit: cover;"/>
                      <div class="label-text big-size ellipsis-text">
                        {{ item.title || '제목을 입력해주세요' }}
                      </div>
                      <div class="sub-text" v-if="item.description" style="white-space: pre-line;">
                        {{ item.description }}
                      </div>
                      <div class="sub-text" v-if="item.date">
                        {{ item.date }}
                      </div>
                    </div>
                  </div>
                  <!-- 기타 타입: 기존 스타일 유지 -->
                  <div v-else :class="getCustomSectionWrapperClass(getCustomSectionById(sectionKey).type)">
                    <div class="clickable-section"
                    :class="getCustomSectionItemClass(getCustomSectionById(sectionKey).type)"
                    v-for="(item,itemIndex) in getCustomSectionById(sectionKey).items" :key="`custom-section-${sectionKey}-${itemIndex}`"
                    @click="openLink(item.link)">
                      <img :src="item.fileList[0]?.url||defaultImage" alt="이미지" v-if="getCustomSectionById(sectionKey).type === 'image-list' || getCustomSectionById(sectionKey).type === 'image-news-list'"/>
                      <div :class="getCustomSectionContentClass(getCustomSectionById(sectionKey).type)" class="__content" :style="getCustomSectionById(sectionKey).type !== 'image-list' ? 'width: calc(100% - 60px);' : ''">
                        <p :class="getCustomSectionTitleClass(getCustomSectionById(sectionKey).type)" class="ellipsis-text">{{ item.title||'제목을 입력해주세요' }}</p>
                        <p v-if="getCustomSectionById(sectionKey).type !== 'image-list'" :class="getCustomSectionDescClass(getCustomSectionById(sectionKey).type)" class="ellipsis-text">{{ item.description||'설명을 입력해주세요' }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>

            <div class="brand-preview-section__inner__content" style="padding: 0px 20px 20px 20px;" :ref="setItemRef" data-section-key="info" >
              <div class="label-text big-size">
                기본 정보
              </div>
              <div class="infomation-list">
                <div class="infomation-wrap">
                  <div class="infomation__label">사업자명</div>
                  <div class="infomation__text">{{ companyName }}</div>
                </div>
                <div class="infomation-wrap">
                  <div class="infomation__label">주소</div>
                  <div class="infomation__text">{{ companyAddress }}</div>
                </div>
                <div class="infomation-wrap">
                  <div class="infomation__label">사업자등록번호</div>
                  <div class="infomation__text">{{companyBusinessNumber}}</div>
                </div>
              </div>
            </div>

            
            <div class="brand-preview-section__inner__content" style="padding: 0px 20px 20px 20px;" :ref="setItemRef" data-section-key="bottomButton" >
              <a-button :style="{backgroundColor: bottomButton.hexColor}" @click="openLink(bottomButton.link)">
                <span>{{ bottomButton.text }}</span>
              </a-button>
            </div>


          </div>
        </div>
        <div class="brand-settings-section" ref="settingsSection" @scroll="handleSettingsScroll">
          <!-- 섹션 순서 관리 - 맨 위 배치 -->
          <div class="inner-section" data-section-key="sectionOrder">
            <div class="label-text big-size">섹션 순서 관리</div>
            <div class="sub-text" style="margin-bottom: 16px;">
              드래그하여 섹션 순서를 변경하고, 스위치로 표시 여부를 설정할 수 있습니다.
            </div>
            <draggable
              :list="sectionOrder"
              ghost-class="section-order-item--ghost"
              drag-class="section-order-item--drag"
              class="section-order-list"
              :options="{ handle: '.drag-handle' }"
            >
              <div
                class="section-order-item"
                v-for="(key, index) in sectionOrder"
                :key="key"
              >
                <div class="drag-handle">
                  <i class="fa-solid fa-grip-vertical"></i>
                </div>
                <div class="section-order-item__info">
                  <span class="section-order-item__number">{{ index + 1 }}</span>
                  <span class="section-order-item__title">{{ getSectionDisplayTitle(key) }}</span>
                </div>
                <div class="section-order-item__actions">
                  <a-switch
                    :checked="getSectionIsShow(key)"
                    @change="(checked) => toggleSectionVisibility(key, checked)"
                    size="small"
                  />
                </div>
              </div>
            </draggable>
          </div>
          <div class="inner-section" data-section-key="header">
            <div class="label-text big-size">기본 설정</div>
            <div class="label-text required">브랜드 명</div>
            <a-input v-model:value="brandName" placeholder="브랜드 명을 입력해주세요." />
            <div class="label-text required">로고 이미지</div>
                <a-upload
                  :file-list="brandLogo.fileList"
                  :max-count="1"
                  :multiple="false"
                  list-type="picture-card"
                  :show-upload-list="false"
                  :before-upload="(file, fileList) => handleBeforeUpload(file, fileList,brandLogo)"
                  @change="(info) => handleImageChange(info, brandLogo)"
                  :custom-request="customRequest"
                  :accept="acceptImageTypes"
                >
                  <div v-if="brandLogo.fileList.length === 0">
                    <plus-outlined />
                    <div style="margin-top: 8px">업로드</div>
                  </div>
                  <div v-else class="custom-upload-item">
                    <img :src="brandLogo.fileList[0]?.url || brandLogo.fileList[0]?.thumbUrl" />
                    <div class="custom-upload-item__actions">
                      <i class="fa-solid fa-download" @click.stop="handleDownload(brandLogo.fileList[0])"></i>
                      <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(brandLogo)"></i>
                    </div>
                  </div>
                </a-upload>
            <div class="sub-text">
              형식: PNG, JPG / 사이즈: 200×200px / 파일 크기: 1MB 이내
            </div>
            <div class="label-text required">배경 이미지</div>
                <a-upload
                  :file-list="mainBg.fileList"
                  :max-count="1"
                  :multiple="false"
                  list-type="picture-card"
                  :show-upload-list="false"
                  :before-upload="(file, fileList) => handleBeforeUpload(file, fileList,mainBg)"
                  @change="(info) => handleImageChange(info, mainBg)"
                  :custom-request="customRequest"
                  :accept="acceptImageTypes"
                >
                  <div v-if="mainBg.fileList.length === 0">
                    <plus-outlined />
                    <div style="margin-top: 8px">업로드</div>
                  </div>
                  <div v-else class="custom-upload-item">
                    <img :src="mainBg.fileList[0]?.url || mainBg.fileList[0]?.thumbUrl" />
                    <div class="custom-upload-item__actions">
                      <i class="fa-solid fa-download" @click.stop="handleDownload(mainBg.fileList[0])"></i>
                      <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(mainBg)"></i>
                    </div>
                  </div>
                </a-upload>
            <div class="sub-text">
              형식: PNG, JPG / 사이즈: 900×600px / 파일 크기: 5MB 이내
            </div>
            <div style="background:#EBEEEF; height:1px; margin: 36px -36px;"></div>
            <div class="label-text big-size">메인 버튼</div>
            <div class="label-text required">버튼 텍스트</div>
            <a-input
              :value="mainButton.text"
              @input="(event) => mainButton.text = event.target.value"
              placeholder="버튼 텍스트를 입력해주세요."
            />
            <div class="label-text required">버튼 컬러</div>
            <a-input :value="mainDisplayValue" readonly>
              <template #addonBefore>
                <ColorPicker v-model:pureColor="mainButton.color" v-model:alpha="mainButton.alpha" />
              </template>
            </a-input>
            <div class="label-text">버튼 링크</div>
            <a-input
              :value="mainButton.link"
              @input="(event) => mainButton.link = event.target.value"
              placeholder="https://example.com"
            />
          </div>
          <!-- 섹션 순서대로 설정 영역 렌더링 -->
          <template v-for="sectionKey in sectionOrder" :key="`settings-${sectionKey}`">
            <!-- couponList 설정 -->
            <div class="inner-section" v-if="sectionKey === 'couponList'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(쿠폰)</span>
                <a-switch v-model:checked="couponList.isShow" style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="couponList.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <div class="deleteable-section" v-for="(item,index) in couponList.items" :key="`coupon-${index}`">
                <div class="deleteabled-section__header">
                  {{couponList.title}} {{ index + 1 }}
                  <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(couponList,index)"></i>
                </div>
                <div class="deleteabled-section__content">
                  <div class="label-text required">이미지</div>
                  <a-upload
                    :file-list="item.fileList"
                    :max-count="1"
                    :multiple="false"
                    list-type="picture-card"
                    :show-upload-list="false"
                    :before-upload="(file, fileList) => handleBeforeUpload(file, fileList, item)"
                    @change="(info) => handleImageChange(info, item)"
                    :custom-request="customRequest"
                    :accept="acceptImageTypes"
                  >
                    <div v-if="item.fileList.length === 0">
                      <plus-outlined />
                      <div style="margin-top: 8px">업로드</div>
                    </div>
                    <div v-else class="custom-upload-item">
                      <img :src="item.fileList[0]?.url || item.fileList[0]?.thumbUrl" />
                      <div class="custom-upload-item__actions">
                        <i class="fa-solid fa-download" @click.stop="handleDownload(item.fileList[0])"></i>
                        <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(item)"></i>
                      </div>
                    </div>
                  </a-upload>
                  <div class="sub-text">
                    형식: PNG, JPG / 파일 크기: 5MB 이내
                  </div>

                  <div class="label-text">제목</div>
                  <a-input v-model:value="item.title" placeholder="쿠폰 제목을 입력해주세요. (선택)" />
                  <div class="label-text">링크(URL)</div>
                  <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요. (선택)" />
                </div>
              </div>
              <a-button class="add-new-content-button" @click="()=>addNewSubItem(couponList)">
                <i class="fa-solid fa-plus"></i>
                <span>{{couponList.title}} 추가</span>
              </a-button>
            </div>

            <!-- certificateList 설정 -->
            <div class="inner-section" v-else-if="sectionKey === 'certificateList'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(인증서)</span>
                <a-switch v-model:checked="certificateList.isShow" style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="certificateList.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <div class="deleteable-section" v-for="(item,index) in certificateList.items" :key="`cert-${index}`">
                <div class="deleteabled-section__header">
                  {{certificateList.title}} {{ index + 1 }}
                  <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(certificateList,index)"></i>
                </div>
                <div class="deleteabled-section__content">
                  <div class="label-text required">썸네일</div>
                  <a-upload
                    :file-list="item.fileList"
                    :max-count="1"
                    :multiple="false"
                    list-type="picture-card"
                    :show-upload-list="false"
                    :before-upload="(file, fileList) => handleBeforeUpload(file, fileList, item)"
                    @change="(info) => handleImageChange(info, item)"
                    :custom-request="customRequest"
                    :accept="acceptImageTypes"
                  >
                    <div v-if="item.fileList.length === 0">
                      <plus-outlined />
                      <div style="margin-top: 8px">업로드</div>
                    </div>
                    <div v-else class="custom-upload-item">
                      <img :src="item.fileList[0]?.url || item.fileList[0]?.thumbUrl" />
                      <div class="custom-upload-item__actions">
                        <i class="fa-solid fa-download" @click.stop="handleDownload(item.fileList[0])"></i>
                        <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(item)"></i>
                      </div>
                    </div>
                  </a-upload>
                  <div class="sub-text">
                    형식: PNG, JPG / 사이즈: 200×200px / 파일 크기: 5MB 이내
                  </div>

                  <div class="label-text">제목</div>
                  <a-input v-model:value="item.title" placeholder="인증서 제목을 입력해주세요. (선택)" />
                  <div class="label-text">날짜</div>
                  <a-input v-model:value="item.date" placeholder="날짜를 입력해주세요. (선택)" />
                  <div class="label-text">링크(URL)</div>
                  <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요. (선택)" />
                </div>
              </div>
              <a-button class="add-new-content-button" @click="()=>addNewSubItem(certificateList)">
                <i class="fa-solid fa-plus"></i>
                <span>{{certificateList.title}} 추가</span>
              </a-button>
            </div>

            <!-- imageList 설정 (이미지 - 가로 스크롤) -->
            <div class="inner-section" v-else-if="sectionKey === 'imageList'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(이미지)</span>
                <a-switch v-model:checked="imageList.isShow"  style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="imageList.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <div class="deleteable-section" v-for="(item,index) in imageList.items" :key="index">
              <div class="deleteabled-section__header">
                {{imageList.title}} {{ index + 1 }}
                <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(imageList,index)"></i>
              </div>
              <div class="deleteabled-section__content">
                <div class="label-text required">썸네일</div>
                <a-upload
                  :file-list="item.fileList"
                  :max-count="1"
                  :multiple="false"
                  list-type="picture-card"
                  :show-upload-list="false"
                  :before-upload="(file, fileList) => handleBeforeUpload(file, fileList, item)"
                  @change="(info) => handleImageChange(info, item)"
                  :custom-request="customRequest"
                  :accept="acceptImageTypes"
                >
                  <div v-if="item.fileList.length === 0">
                    <plus-outlined />
                    <div style="margin-top: 8px">업로드</div>
                  </div>
                  <div v-else class="custom-upload-item">
                    <img :src="item.fileList[0]?.url || item.fileList[0]?.thumbUrl" />
                    <div class="custom-upload-item__actions">
                      <i class="fa-solid fa-download" @click.stop="handleDownload(item.fileList[0])"></i>
                      <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(item)"></i>
                    </div>
                  </div>
                </a-upload>
                <div class="sub-text">
                  형식: PNG, JPG / 사이즈: 140×140px / 파일 크기: 5MB 이내
                </div>
                <div class="label-text required">제목</div>
                <a-input v-model:value="item.title" placeholder="제목을 입력해주세요." />
                <div class="label-text required">링크(URL)</div>
                <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요." />
              </div>
            </div>
            <a-button class="add-new-content-button" @click="()=>addNewSubItem(imageList)">
              <i class="fa-solid fa-plus"></i>
              <span>{{imageList.title}} 추가</span>
            </a-button>
            </div>

            <!-- bigImageList 설정 (큰 이미지) -->
            <div class="inner-section" v-else-if="sectionKey === 'bigImageList'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(큰 이미지)</span>
                <a-switch v-model:checked="bigImageList.isShow"  style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="bigImageList.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <div class="deleteable-section" v-for="(item,index) in bigImageList.items" :key="index">
              <div class="deleteabled-section__header">
                {{bigImageList.title}} {{ index + 1 }}
                <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(bigImageList,index)"></i>
              </div>
              <div class="deleteabled-section__content">
                <div class="label-text required">썸네일</div>
                <a-upload
                  :file-list="item.fileList"
                  :max-count="1"
                  :multiple="false"
                  list-type="picture-card"
                  :show-upload-list="false"
                  :before-upload="(file, fileList) => handleBeforeUpload(file, fileList, item)"
                  @change="(info) => handleImageChange(info, item)"
                  :custom-request="customRequest"
                  :accept="acceptImageTypes"
                >
                  <div v-if="item.fileList.length === 0">
                    <plus-outlined />
                    <div style="margin-top: 8px">업로드</div>
                  </div>
                  <div v-else class="custom-upload-item">
                    <img :src="item.fileList[0]?.url || item.fileList[0]?.thumbUrl" />
                    <div class="custom-upload-item__actions">
                      <i class="fa-solid fa-download" @click.stop="handleDownload(item.fileList[0])"></i>
                      <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(item)"></i>
                    </div>
                  </div>
                </a-upload>
                <div class="sub-text">
                  형식: PNG, JPG / 사이즈: 960×540px / 파일 크기: 5MB 이내
                </div>
                <div class="label-text required">제목</div>
                <a-input v-model:value="item.title" placeholder="제목을 입력해주세요." />
                <div class="label-text">설명</div>
                <a-input v-model:value="item.description" placeholder="설명을 입력해주세요. (선택)" />
                <div class="label-text">날짜</div>
                <a-input v-model:value="item.date" placeholder="날짜를 입력해주세요. (선택)" />
                <div class="label-text required">링크(URL)</div>
                <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요." />
              </div>
            </div>
            <a-button class="add-new-content-button" @click="()=>addNewSubItem(bigImageList)">
              <i class="fa-solid fa-plus"></i>
              <span>{{bigImageList.title}} 추가</span>
            </a-button>
            </div>

            <!-- imageNewsList 설정 -->
            <div class="inner-section" v-else-if="sectionKey === 'imageNewsList'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(이미지뉴스)</span>
                <a-switch v-model:checked="imageNewsList.isShow"  style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="imageNewsList.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <div class="deleteable-section" v-for="(item,index) in imageNewsList.items" :key="index">
                <div class="deleteabled-section__header">
                  {{imageNewsList.title}} {{ index + 1 }}
                  <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(imageNewsList,index)"></i>
                </div>
                <div class="deleteabled-section__content">
                  <div class="label-text required">썸네일</div>
                  <a-upload
                  :file-list="item.fileList"
                  :max-count="1"
                  :multiple="false"
                  list-type="picture-card"
                  :show-upload-list="false"
                  :before-upload="(file, fileList) => handleBeforeUpload(file, fileList, item)"
                  @change="(info) => handleImageChange(info, item)"
                  :custom-request="customRequest"
                  :accept="acceptImageTypes"
                >
                  <div v-if="item.fileList.length === 0">
                    <plus-outlined />
                    <div style="margin-top: 8px">업로드</div>
                  </div>
                  <div v-else class="custom-upload-item">
                    <img :src="item.fileList[0]?.url || item.fileList[0]?.thumbUrl" />
                    <div class="custom-upload-item__actions">
                      <i class="fa-solid fa-download" @click.stop="handleDownload(item.fileList[0])"></i>
                      <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(item)"></i>
                    </div>
                  </div>
                </a-upload>
                <div class="sub-text">
                  형식: PNG, JPG / 사이즈: 960×540px / 파일 크기: 5MB 이내
                </div>

                <div class="label-text required">제목</div>
                <a-input v-model:value="item.title" placeholder="제목을 입력해주세요." />
                <div class="label-text required">설명</div>
                <a-input v-model:value="item.description" placeholder="설명을 입력해주세요." />
                <div class="sub-text">최소 10자 ~ 최대 100자 입력 (공백 포함)</div>
                <div class="label-text required">링크(URL)</div>
                <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요." />
              </div>
            </div>
              <a-button class="add-new-content-button" @click="()=>addNewSubItem(imageNewsList)">
                <i class="fa-solid fa-plus"></i>
                <span>{{imageNewsList.title}} 추가</span>
              </a-button>
            </div>

            <!-- cardList 설정 -->
            <div class="inner-section" v-else-if="sectionKey === 'cardList'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(카드)</span>
                <a-switch v-model:checked="cardList.isShow"  style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="cardList.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <div class="deleteable-section" v-for="(item,index) in cardList.items" :key="index">
                <div class="deleteabled-section__header">
                  {{cardList.title}} {{ index + 1 }}
                  <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(cardList,index)"></i>
                </div>
                <div class="deleteabled-section__content">
                  <div class="label-text required">제목</div>
                  <a-input v-model:value="item.title" placeholder="제목을 입력해주세요." />
                  <div class="label-text required">설명</div>
                  <a-input v-model:value="item.description" placeholder="설명을 입력해주세요." />
                  <div class="sub-text">최소 10자 ~ 최대 100자 입력 (공백 포함)</div>
                  <div class="label-text required">링크(URL)</div>
                  <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요." />
                </div>
              </div>
              <a-button class="add-new-content-button" @click="()=>addNewSubItem(cardList)">
                <i class="fa-solid fa-plus"></i>
                <span>{{cardList.title}} 추가</span>
              </a-button>
            </div>

            <!-- newsList 설정 -->
            <div class="inner-section" v-else-if="sectionKey === 'newsList'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(뉴스)</span>
                <a-switch v-model:checked="newsList.isShow"  style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="newsList.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <div class="deleteable-section" v-for="(item,index) in newsList.items" :key="index">
                <div class="deleteabled-section__header">
                  {{newsList.title}} {{ index + 1 }}
                  <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(newsList,index)"></i>
                </div>
                <div class="deleteabled-section__content">
                  <div class="label-text required">제품/서비스명</div>
                  <a-input v-model:value="item.title" placeholder="브랜드명을 입력해주세요." />
                  <div class="label-text required">설명</div>
                  <a-input v-model:value="item.description" placeholder="설명을 입력해주세요." />
                  <div class="sub-text">최소 10자 ~ 최대 100자 입력 (공백 포함)</div>
                  <div class="label-text required">링크(URL)</div>
                  <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요." />
                </div>
            </div>
              <a-button class="add-new-content-button" @click="()=>addNewSubItem(newsList)">
                <i class="fa-solid fa-plus"></i>
                <span>{{newsList.title}} 추가</span>
              </a-button>
            </div>

            <!-- officialChannels 설정 -->
            <div class="inner-section" v-else-if="sectionKey === 'officialChannels'" :data-section-key="sectionKey">
              <div class="label-text big-size">
                섹션 타이틀 <span style="color: #8D939A; font-weight: normal;">(공식 채널)</span>
                <a-switch v-model:checked="officialChannels.isShow"  style="margin-left: auto;"/>
              </div>
              <a-input v-model:value="officialChannels.title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 16px;" />
              <draggable
                :list="officialChannels.items"
                :options="{ handle: '.channel-drag-handle' }"
              >
                <div v-for="(item, index) in officialChannels.items" :key="index" style="margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #EBEBEB;">
                  <div class="label-text" style="display: flex; align-items: center;">
                    <i class="fa-solid fa-grip-vertical channel-drag-handle" style="cursor: grab; margin-right: 8px; color: #8D939A;"></i>
                    {{item.title || '새 채널'}}
                    <a-switch v-model:checked="item.isShow" style="margin-left: auto;" size="small"/>
                  </div>
                  <div style="display: flex; gap: 16px; align-items: flex-start;">
                    <div>
                      <div class="label-text" style="font-size: 12px; margin-bottom: 4px;">아이콘</div>
                      <a-upload
                        :file-list="item.fileList"
                        :max-count="1"
                        :multiple="false"
                        list-type="picture-card"
                        :show-upload-list="false"
                        :before-upload="(file, fileList) => handleBeforeUpload(file, fileList, item)"
                        @change="(info) => handleImageChange(info, item)"
                        class="channel-icon-upload"
                      >
                        <div v-if="item.fileList.length > 0" class="custom-upload-item channel-icon">
                          <img :src="item.fileList[0]?.url || item.fileList[0]?.thumbUrl"
                               alt="채널 아이콘"
                               style="width: 60px; height: 60px; object-fit: cover; border-radius: 50%;" />
                          <div class="custom-upload-item__actions">
                            <i class="fa-solid fa-download" @click.stop="handleDownload(item.fileList[0])"></i>
                            <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(item)"></i>
                          </div>
                        </div>
                        <img v-else-if="item.defaultImage"
                             :src="item.defaultImage"
                             alt="채널 아이콘"
                             style="width: 60px; height: 60px; object-fit: cover; border-radius: 50%;" />
                        <div v-else style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 60px; height: 60px; border: 1px dashed #d9d9d9; border-radius: 50%;">
                          <i class="fa-solid fa-plus"></i>
                        </div>
                      </a-upload>
                    </div>
                    <div style="flex: 1;">
                      <div class="label-text" style="font-size: 12px; margin-bottom: 4px;">채널명</div>
                      <a-input v-model:value="item.title" placeholder="채널명을 입력해주세요." style="margin-bottom: 8px;" />
                      <div class="label-text" style="font-size: 12px; margin-bottom: 4px;">링크 URL</div>
                      <a-input v-model:value="item.link" placeholder="채널 주소(URL)을 입력해주세요." />
                    </div>
                  </div>
                </div>
              </draggable>
              <a-button class="add-new-content-button" @click="()=>addNewChannelItem()">
                <i class="fa-solid fa-plus"></i>
                <span>{{officialChannels.title}} 추가</span>
              </a-button>
            </div>

            <!-- customSection-* 개별 추가 섹션 설정 -->
            <div class="inner-section" v-else-if="isCustomSectionKey(sectionKey) && getCustomSectionById(sectionKey)" :data-section-key="sectionKey">
              <div class="label-text big-size">
                추가 섹션
              </div>
              <div>
                <div style="display: flex; align-items: center;">
                  <div class="label-text required">
                    섹션 타이틀
                  </div>
                  <a-switch v-model:checked="getCustomSectionById(sectionKey).isShow"  style="margin-left: auto; margin-right: 20px;"/>
                  <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItemForCustomSection(sectionKey)"></i>
                </div>
                <a-input v-model:value="getCustomSectionById(sectionKey).title" placeholder="섹션 타이틀을 입력해주세요." style="margin-bottom: 10px;" />
                <div class="label-text" style="margin: 0 0 20px 0;">섹션 타입</div>
                <a-radio-group v-model:value="getCustomSectionById(sectionKey).type" placeholder="섹션 타입을 선택해주세요." style="margin: 0 0 20px 0;">
                  <a-radio v-for="(type,typeIdx) in sectionTypes" :key="typeIdx" :value="type.value">
                    {{type.label}}
                  </a-radio>
                </a-radio-group>
                <div class="deleteable-section" v-for="(item,itemIdx) in getCustomSectionById(sectionKey).items" :key="itemIdx" style="margin-bottom: 20px;">
                  <div class="deleteabled-section__header">
                    {{getCustomSectionById(sectionKey).title}} {{ itemIdx + 1 }}
                    <i class="fa-solid fa-trash-can" style="cursor: pointer; margin-left: auto;" @click="()=>deleteItem(getCustomSectionById(sectionKey),itemIdx)"></i>
                  </div>
                  <div class="deleteabled-section__content">
                    <div class="label-text" v-show="getCustomSectionById(sectionKey).type === 'image-list' || getCustomSectionById(sectionKey).type === 'image-news-list'">썸네일</div>
                    <a-upload
                      v-show="getCustomSectionById(sectionKey).type === 'big-image-list' || getCustomSectionById(sectionKey).type === 'image-list' || getCustomSectionById(sectionKey).type === 'image-news-list'"
                      :file-list="item.fileList"
                      :max-count="1"
                      :multiple="false"
                      list-type="picture-card"
                      :show-upload-list="false"
                      :before-upload="(file, fileList) => handleBeforeUpload(file, fileList, item)"
                      @change="(info) => handleImageChange(info, item)"
                      :custom-request="customRequest"
                      :accept="acceptImageTypes"
                    >
                      <div v-if="item.fileList.length === 0">
                        <plus-outlined />
                        <div style="margin-top: 8px">업로드</div>
                      </div>
                      <div v-else class="custom-upload-item">
                        <img :src="item.fileList[0]?.url || item.fileList[0]?.thumbUrl" />
                        <div class="custom-upload-item__actions">
                          <i class="fa-solid fa-download" @click.stop="handleDownload(item.fileList[0])"></i>
                          <i class="fa-solid fa-trash-can" @click.stop="handleRemoveFile(item)"></i>
                        </div>
                      </div>
                    </a-upload>
                    <div class="sub-text" v-show="getCustomSectionById(sectionKey).type === 'image-list' || getCustomSectionById(sectionKey).type === 'image-news-list'">
                      형식: PNG, JPG / 사이즈: 960×540px / 파일 크기: 5MB 이내
                    </div>
                    <div class="label-text required">제목</div>
                    <a-input v-model:value="item.title" placeholder="제목을 입력해주세요." />
                    <div v-show="getCustomSectionById(sectionKey).type !== 'image-list'">
                      <div class="label-text required">설명</div>
                      <a-input v-model:value="item.description" placeholder="상세 설명을 입력해주세요." />
                      <div class="sub-text">최소 10자 ~ 최대 100자 입력 (공백 포함)</div>
                    </div>
                    <div class="label-text required">링크(URL)</div>
                    <a-input v-model:value="item.link" placeholder="링크(URL)를 입력해주세요." />
                  </div>
                </div>
                <a-button class="add-new-content-button" @click="()=>addNewSubItem(getCustomSectionById(sectionKey))" style="width:100%; margin:0;">
                  <i class="fa-solid fa-plus"></i>
                  <span>항목 추가</span>
                </a-button>
              </div>
            </div>
          </template>
          <!-- 섹션 순서 템플릿 끝 -->

          <div style="background:#D1D6DB; height: 60px; display: flex; align-items: center; justify-content: center;">
            <a-button class="add-new-content-button" style="width:100%; margin:0;" @click="()=>addNewSection()">
              <i class="fa-solid fa-plus"></i>
              <span>섹션 추가</span>
            </a-button>
          </div>
          <div class="inner-section" data-section-key="info">
            <div class="label-text big-size">기본 정보</div>
            <div class="label-text required">사업자명</div>
            <a-input v-model:value="companyName" placeholder="사업자명을 입력해주세요." />
            <div class="label-text required">주소</div>
            <a-input v-model:value="companyAddress" v-show="companyAddress" placeholder="주소를 입력해주세요." />
            <a-button @click="searchAddress">
              <i class="fa-solid fa-location-dot"></i>
              <span>주소 검색</span>
            </a-button>
            <div class="label-text required">사업등록번호</div>
            <a-input v-model:value="companyBusinessNumber" placeholder="000-00-000000" />
          </div>
          <div class="inner-section" data-section-key="bottomButton">
            <div class="label-text big-size">페이지 하단 버튼</div>
            <div class="label-text required">버튼 텍스트</div>
            <a-input
              :value="bottomButton.text"
              @input="(event) => bottomButton.text = event.target.value"
              placeholder="버튼 텍스트를 입력해주세요."
            />
            <div class="label-text required">버튼 컬러</div>
            <a-input :value="bottomDisplayValue" readonly>
              <template #addonBefore>
                <ColorPicker v-model:pureColor="bottomButton.color" v-model:alpha="bottomButton.alpha" />
              </template>
            </a-input>
            <div class="label-text">버튼 링크</div>
            <a-input
              :value="bottomButton.link"
              @input="(event) => bottomButton.link = event.target.value"
              placeholder="https://example.com"
            />
          </div>
        </div>

      </div>
    </main>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/tokenStore';
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import { message } from 'ant-design-vue';
import { jwtDecoder, oneBtnDialog } from '@/utils/utils';
import { canOpen } from '@/router';
import { VueDraggableNext } from 'vue-draggable-next';
export default {
  name: 'BrandSettings',
  components: {
    ColorPicker,
    draggable: VueDraggableNext,
  },
  data() {
    return {
      sections: [],
      settingSections: [],
      isScrollSyncing: false,
      lastSyncedSection: null,
      scrollThrottleTimer: null,
      // 섹션 순서 관리 배열 - 표시되는 섹션만 순서대로 포함
      sectionOrder: ['couponList', 'certificateList', 'imageList', 'bigImageList', 'imageNewsList', 'cardList', 'newsList', 'officialChannels'],
      // 모든 섹션 정의 (key, title, 참조할 데이터 키) - 고정 섹션만 포함, 커스텀 섹션은 동적으로 추가됨
      allSectionDefinitions: [
        { key: 'certificateList', title: '내 인증서 보기' },
        { key: 'couponList', title: '쿠폰함' },
        { key: 'imageList', title: '브랜드 소식' },
        { key: 'bigImageList', title: '이벤트' },
        { key: 'imageNewsList', title: '자이스 스마일 알아보기' },
        { key: 'cardList', title: '스마일 카드 알아보기' },
        { key: 'newsList', title: '보도자료' },
        { key: 'officialChannels', title: '공식 채널' },
      ],
      // 고정 섹션 키 목록 (커스텀 섹션 구분용)
      fixedSectionKeys: ['couponList', 'certificateList', 'imageList', 'bigImageList', 'imageNewsList', 'cardList', 'newsList', 'officialChannels'],
      // 내 인증서 보기 섹션
      certificateList: {
        title: '내 인증서 보기',
        isShow: true,
        items: [
          {
            maxSize: 5,
            fileList: [
              {
                url: require('@/assets/img/brand/smile-card.png'),
              },
            ],
            title: '스마일 라식 확인서',
            date: '2024-06-01',
            link: '',
          },
        ],
      },
      uploadPath: "product-v2/categories",
      acceptImageTypes: 'image/jpeg,image/png,image/gif,image/svg+xml,image/webp',
      brandLogo: {
        maxSize: 1,
        fileList: [
          {
            url: require('@/assets/img/brand/logo.png'),
          },
        ],
      },
      mainBg: {
        maxSize: 5,
        fileList: [
          {
            url: require('@/assets/img/brand/main-bg.png'),
          },
        ],
      },
      companyName: '',
      brandName: '자이스코리아',
      companyImage: '',
      companyAddress: '',
      companyBusinessNumber: '203-81-5151',
      // 메인 버튼
      mainButton: {
        text: '자이스 스마일 병원 알아보기',
        color: '#141E8C',
        hexColor: '#141E8C',
        alpha: 1,
        link: ''
      },
      // 페이지 하단 버튼
      bottomButton: {
        text: '자이스 스마일 병원 알아보기',
        color: '#141E8C',
        hexColor: '#141E8C',
        alpha: 1,
        link: ''
      },
      defaultImage: require('@/assets/img/brand/default-image.webp'),
      imageList :{
        title: "브랜드 소식",
        isShow: true,
        items: [
          {
            maxSize: 5,
            fileList: [
              {
                url: require('@/assets/img/brand/news.png'),
              },
            ],
            title: "홀리데이 정품 인증 이벤트",
            link: "https://www.google.com",
          },
        ],
      },
      bigImageList :{
        title: "이벤트",
        isShow: true,
        items: [
          {
            maxSize: 5,
            fileList: [
              {
                url: require('@/assets/img/brand/news.png'),
              },
            ],
            title: "[2024 소비자의 선택] 안정성 인정받아 1000만 안 이상 수술 달성",
            description: "",
            date: "2024-12-12",
            link: "https://www.google.com",
          },
        ],
      },
      imageNewsList: {
        title: "자이스 스마일 알아보기",
        isShow: true,
        items: [
          {
            maxSize: 5,
            fileList: [
              {
                url: require('@/assets/img/brand/eyes-icon.png'),
              },
            ],
            title: "자이스 스마일",
            description: "시력 교정을 위한 최소 침습 레이저 시력교정술",
            link: "https://www.google.com",
          },
          {
            maxSize: 5,
            fileList: [
              {
                url: require('@/assets/img/brand/eyes-icon.png'),
              },
            ],
            title: "자이스 스마일 프로",
            description: "시력교정의 정점, 한층 업그레이드된 프리미엄 시력교정술 (최대 2줄까지 작성 가능)",
            link: "https://www.google.com",
          },
          {
            maxSize: 5,
            fileList: [
              {
                url: require('@/assets/img/brand/eyes-icon.png'),
              },
            ],
            title: "시력 교정술 한눈에 보기",
            description: "환자들을 위한 ZEISS의 의료 기술 알아보기",
            link: "https://www.google.com",
          },
        ],
      },
      cardList: {
        title: "스마일 카드 알아보기",
        isShow: true,
        items: [
          {
            title: "서티라이프 스마일 카드 소식",
            description: "서티라이프 x 자이스 스마일 카드 도입 관련 소식, 한글 단어 잘림 방지 처리, 최대 2줄까지 작성 가능하며, 글자수가 많을 경우 ...",
            link: "https://www.google.com",
          },
          {
            title: "서티라이프 스마일 카드 소식",
            description: "서티라이프 x 자이스 스마일 카드 도입 관련 소식, 한글 단어 잘림 방지 처리, 최대 2줄까지 작성 가능하며, 글자수가 많을 경우 ...",
            link: "https://www.google.com",
          },
        ],
      },
      newsList: {
        isShow: true,
        title: "보도자료",
        items: [
          {
            title: "서티라이프, 자이스 코리아와 NFT 인증...",
            description: "안과 병원 업무협약 맞춰, 확인서 카드에 정품 정보 삽입 사전 획기적 단축 (최대 2줄까지 작성 가능)",
            link: "https://www.google.com",
          },
          {
            title: "서티라이프, 자이스 코리아와 NFT 인증...",
            description: "안과 병원 업무협약 맞춰, 확인서 카드에 정품 정보 삽입 사전 획기적 단축 (최대 2줄까지 작성 가능)",
            link: "https://www.google.com",
          },
          {
            title: "서티라이프, 자이스 코리아와 NFT 인증...",
            description: "안과 병원 업무협약 맞춰, 확인서 카드에 정품 정보 삽입 사전 획기적 단축 (최대 2줄까지 작성 가능)",
            link: "https://www.google.com",
          },
        ],
      },
      officialChannels: {
        isShow: true,
        title: "공식 채널",
        items: [
          {
            title: "카카오톡",
            defaultImage: require('@/assets/img/brand/kakaotalk.png'),
            fileList: [],
            link: "",
            isShow: true,
          },
          {
            title: "홈페이지",
            defaultImage: require('@/assets/img/brand/homepage.png'),
            fileList: [],
            link: "",
            isShow: true,
          },
          {
            title: "인스타그램",
            defaultImage: require('@/assets/img/brand/instagram.png'),
            fileList: [],
            link: "",
            isShow: true,
          },
          {
            title: "유튜브",
            defaultImage: require('@/assets/img/brand/youtube.png'),
            fileList: [],
            link: "",
            isShow: true,
          },
        ],
      },
      // 쿠폰함 섹션
      couponList: {
        title: '쿠폰함',
        isShow: true,
        items: [
          {
            maxSize: 5,
            fileList: [],
            title: '',
            link: '',
          }
        ],
      },
      customSections: {
        sections: [
          {
            id: 'customSection-default-1',
            isShow: true,
            title: '커스텀 섹션',
            type: 'big-image-list', // 섹션 타입 (이미지 리스트, 카드 리스트, 뉴스 리스트 등)
            items: [
              {
                maxSize: 5, // 파일 크기 제한 (MB)
                fileList: [], // 이미지 파일 리스트
                title: '',
                description: '',
                date: '',
                link: '',
              }
            ]
          }
        ]
      },
      // 섹션 타입 정의
      sectionTypes: [
        {
          value: 'big-image-list',
          label: '큰 이미지',
          allowedFields: ['title', 'description', 'image', 'link']
        },
        {
          value: 'image-list',
          label: '이미지',
          allowedFields: ['title', 'image', 'link']
        },
        {
          value: 'image-news-list',
          label: '이미지뉴스',
          allowedFields: ['title', 'description', 'image', 'link']
        },
        {
          value: 'card-list',
          label: '카드',
          allowedFields: ['title', 'description', 'link']
        },
        {
          value: 'news-list',
          label: '뉴스',
          allowedFields: ['title', 'description', 'link']
        }
      ],
      isActiveWebLink: false, // 웹 링크 활성화 여부
    }
  },

  computed: {
    canOpenShareLinks() {
      return canOpen('/share-links');
    },
    mainDisplayValue() {
      return `${this.mainButton.hexColor} / ${Math.round(this.mainButton.alpha * 100)}%`;
    },
    bottomDisplayValue() {
      return `${this.bottomButton.hexColor} / ${Math.round(this.bottomButton.alpha * 100)}%`;
    },
    // sectionOrder 기반으로 정렬된 섹션 목록 (프리뷰 및 설정 영역에서 사용)
    orderedSections() {
      return this.sectionOrder.map(key => {
        const definition = this.allSectionDefinitions.find(d => d.key === key);
        return {
          key,
          title: definition?.title || key,
          data: this.getSectionData(key),
          isShow: this.getSectionIsShow(key),
        };
      }).filter(section => section.data !== null);
    },
    // 표시되는 섹션만 필터링
    visibleOrderedSections() {
      return this.orderedSections.filter(section => section.isShow);
    },
  },
  watch: {
    'mainButton.color'(newColor) {
      console.log(newColor);
      this.mainButton.hexColor = this.rgbToHex(newColor);
      this.mainButton.alpha = this.hexToOpacity(newColor);
    },
    'bottomButton.color'(newColor) {
      this.bottomButton.hexColor = this.rgbToHex(newColor);
      this.bottomButton.alpha = this.hexToOpacity(newColor);
    },
    'customSections.sections': {
      handler(newSections) {
        if (newSections && newSections.length > 0) {
          newSections.forEach((section, idx) => {
            if (!section.id) {
              section.id = `customSection-${Date.now()}-${idx}`;
            }
          });
        }
      },
      immediate: true,
      deep: true
    },
  },
  created() {
    // 컴포넌트 생성시 실행될 로직
    window.addEventListener('scroll', this.handleScroll);
  },
  async mounted(){
    await this.getBrandSettings();
  },
  methods: {
    // 커스텀 섹션 키인지 확인
    isCustomSectionKey(key) {
      return key && key.startsWith('customSection-');
    },
    // 커스텀 섹션 ID로 해당 섹션 데이터 가져오기
    getCustomSectionById(id) {
      return this.customSections.sections.find(s => s.id === id);
    },
    // 커스텀 섹션 ID로 인덱스 가져오기
    getCustomSectionIndexById(id) {
      return this.customSections.sections.findIndex(s => s.id === id);
    },
    // 섹션 키로 해당 섹션 데이터 반환
    getSectionData(key) {
      // 커스텀 섹션인 경우
      if (this.isCustomSectionKey(key)) {
        return this.getCustomSectionById(key);
      }
      const sectionMap = {
        couponList: this.couponList,
        certificateList: this.certificateList,
        imageList: this.imageList,
        bigImageList: this.bigImageList,
        imageNewsList: this.imageNewsList,
        cardList: this.cardList,
        newsList: this.newsList,
        officialChannels: this.officialChannels,
      };
      return sectionMap[key] || null;
    },
    // 섹션 키로 isShow 상태 반환
    getSectionIsShow(key) {
      // 커스텀 섹션인 경우
      if (this.isCustomSectionKey(key)) {
        const customSection = this.getCustomSectionById(key);
        return customSection?.isShow || false;
      }
      const data = this.getSectionData(key);
      return data?.isShow || false;
    },
    // 섹션 표시 타이틀 가져오기 (현재 설정된 타이틀 사용)
    getSectionDisplayTitle(key) {
      // 커스텀 섹션인 경우
      if (this.isCustomSectionKey(key)) {
        const customSection = this.getCustomSectionById(key);
        if (customSection) {
          const typeLabels = {
            'image-list': '이미지',
            'big-image-list': '큰 이미지',
            'image-news-list': '이미지뉴스',
            'card-list': '카드',
            'news-list': '뉴스',
          };
          const typeLabel = typeLabels[customSection.type] || '추가 섹션';
          return `${customSection.title || '커스텀 섹션'} (${typeLabel})`;
        }
        return '추가 섹션';
      }

      // 고정 섹션 타입 라벨 매핑
      const typeLabels = {
        couponList: '쿠폰',
        certificateList: '인증서',
        imageList: '이미지',
        bigImageList: '큰 이미지',
        imageNewsList: '이미지뉴스',
        cardList: '카드',
        newsList: '뉴스',
        officialChannels: null, // 타입 표시 안함
      };

      // 현재 설정된 동적 타이틀 사용
      const sectionData = this.getSectionData(key);
      const title = sectionData?.title || this.allSectionDefinitions.find(d => d.key === key)?.title || key;
      const typeLabel = typeLabels[key];

      return typeLabel ? `${title} (${typeLabel})` : title;
    },
    // 섹션 표시/숨김 토글
    toggleSectionVisibility(key, checked) {
      // 커스텀 섹션인 경우
      if (this.isCustomSectionKey(key)) {
        const customSection = this.getCustomSectionById(key);
        if (customSection) {
          customSection.isShow = checked;
        }
      } else {
        const data = this.getSectionData(key);
        if (data) {
          data.isShow = checked;
        }
      }
    },
    // 추가 섹션 래퍼 클래스 반환
    getCustomSectionWrapperClass(type) {
      switch(type) {
        case 'big-image-list': return 'big-image-list';
        case 'image-list': return 'image-list';
        case 'image-news-list': return 'smile-card-list';
        case 'card-list': return 'smile-card-list';
        case 'news-list': return 'news-list';
        default: return 'news-list';
      }
    },
    // 추가 섹션 아이템 클래스 반환
    getCustomSectionItemClass(type) {
      switch(type) {
        case 'big-image-list': return 'big-image-list__item';
        case 'image-list': return 'image-list__item';
        case 'image-news-list': return 'smile-card-list__item';
        case 'card-list': return 'smile-card-list__item';
        case 'news-list': return 'news-list__item';
        default: return 'news-list__item';
      }
    },
    // 추가 섹션 콘텐츠 클래스 반환
    getCustomSectionContentClass(type) {
      switch(type) {
        case 'big-image-list': return 'big-image-list__item__content';
        case 'image-list': return 'image-list__item__content';
        case 'image-news-list': return 'smile-card-list__item__content';
        case 'card-list': return 'smile-card-list__item__content';
        case 'news-list': return 'news-list__item__content';
        default: return 'news-list__item__content';
      }
    },
    // 추가 섹션 타이틀 클래스 반환
    getCustomSectionTitleClass(type) {
      switch(type) {
        case 'big-image-list': return 'label-text big-size';
        case 'image-list': return 'image-list__item__title';
        case 'image-news-list': return 'smile-card-list__item__title';
        case 'card-list': return 'smile-card-list__item__title';
        case 'news-list': return 'news-list__item__title';
        default: return 'news-list__item__title';
      }
    },
    // 추가 섹션 설명 클래스 반환
    getCustomSectionDescClass(type) {
      switch(type) {
        case 'big-image-list': return 'sub-text';
        case 'image-news-list': return 'smile-card-list__item__description';
        case 'card-list': return 'smile-card-list__item__description';
        case 'news-list': return 'news-list__item__description';
        default: return 'news-list__item__description';
      }
    },
    // 섹션 순서 위로 이동
    moveSectionUp(key) {
      const index = this.sectionOrder.indexOf(key);
      if (index > 0) {
        const temp = this.sectionOrder[index - 1];
        this.sectionOrder[index - 1] = this.sectionOrder[index];
        this.sectionOrder[index] = temp;
        // Vue 반응성을 위해 배열 재할당
        this.sectionOrder = [...this.sectionOrder];
      }
    },
    // 섹션 순서 아래로 이동
    moveSectionDown(key) {
      const index = this.sectionOrder.indexOf(key);
      if (index < this.sectionOrder.length - 1) {
        const temp = this.sectionOrder[index + 1];
        this.sectionOrder[index + 1] = this.sectionOrder[index];
        this.sectionOrder[index] = temp;
        // Vue 반응성을 위해 배열 재할당
        this.sectionOrder = [...this.sectionOrder];
      }
    },
    // sectionOrder 검증 및 정규화
    normalizeSectionOrder(sectionOrder) {
      // 고정 섹션 키 목록
      const fixedKeys = ['couponList', 'certificateList', 'imageList', 'bigImageList', 'imageNewsList', 'cardList', 'newsList', 'officialChannels'];

      // 1. 유효한 키만 필터링 (고정 섹션 + customSection-* 형태)
      let normalized = (sectionOrder || []).filter(key =>
        fixedKeys.includes(key) || this.isCustomSectionKey(key)
      );

      // 2. 누락된 고정 섹션 추가 (맨 뒤에)
      fixedKeys.forEach(key => {
        if (!normalized.includes(key)) {
          normalized.push(key);
        }
      });

      // 3. customSections.sections에 있지만 sectionOrder에 없는 커스텀 섹션 ID 추가
      if (this.customSections && this.customSections.sections) {
        this.customSections.sections.forEach(section => {
          if (section.id && !normalized.includes(section.id)) {
            normalized.push(section.id);
          }
        });
      }

      // 4. 중복 제거
      normalized = [...new Set(normalized)];

      // 5. sectionOrder에는 있지만 customSections.sections에는 없는 커스텀 섹션 제거
      normalized = normalized.filter(key => {
        if (this.isCustomSectionKey(key)) {
          return this.customSections.sections.some(s => s.id === key);
        }
        return true;
      });

      return normalized;
    },
    copyBrandPreviewLink(){
      if(!this.isActiveWebLink){
        oneBtnDialog('알림', '먼저 브랜드관 설정을 저장해주세요.', false);
        return;
      }
      const companyId = jwtDecoder(getAccessToken());
      console.log(process.env.VUE_APP_SERVERURL.replace('inapi','customer'));
      const link = `${process.env.VUE_APP_SERVERURL.replace('inapi','customer')}/brand?companyId=${companyId}`;
      navigator.clipboard.writeText(link);
      oneBtnDialog('알림', '링크가 복사되었습니다.', false);
    },
    // 이미지 오브젝트스토리지에 업로드
    async uploadImage(fileData) {
      try {
        const response = await this.$apiInstance.post(`/object-storages`, fileData);
        console.log(response);
        if (response.status === 200 || response.status === 201) {
          return response.data.url;
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog('알림', '이미지 업로드에 실패했습니다.', false);
        this.hasRequested = false;
      }
    },

    async getBrandSettings(){
      const companyId = jwtDecoder(getAccessToken());
      if(!companyId){
        this.isActiveWebLink = false;
        return;
      }
      const response = await this.$apiInstance.get(`/brands/setting/${companyId}`);
      console.log(response);
      if(response.status === 200 || response.status === 201) {
        let currentBrandSetting = response.data.data;
        if(!currentBrandSetting){
          return false;
        }
        this.isActiveWebLink = true;
        this.brandLogo = currentBrandSetting.brandLogo;
        this.mainBg = currentBrandSetting.mainBg;
        // 각 섹션 로드 시 기본값 유지
        if (currentBrandSetting.imageList) {
          this.imageList = {
            ...this.imageList,
            ...currentBrandSetting.imageList,
            items: currentBrandSetting.imageList.items || [],
          };
        }
        if (currentBrandSetting.bigImageList) {
          this.bigImageList = {
            ...this.bigImageList,
            ...currentBrandSetting.bigImageList,
            items: currentBrandSetting.bigImageList.items || [],
          };
        }
        if (currentBrandSetting.imageNewsList) {
          this.imageNewsList = {
            ...this.imageNewsList,
            ...currentBrandSetting.imageNewsList,
            items: currentBrandSetting.imageNewsList.items || [],
          };
        }
        if (currentBrandSetting.cardList) {
          this.cardList = {
            ...this.cardList,
            ...currentBrandSetting.cardList,
            items: currentBrandSetting.cardList.items || [],
          };
        }
        if (currentBrandSetting.newsList) {
          this.newsList = {
            ...this.newsList,
            ...currentBrandSetting.newsList,
            items: currentBrandSetting.newsList.items || [],
          };
        }
        if (currentBrandSetting.officialChannels) {
          // officialChannels의 items를 새 구조로 변환 (업로드 이미지 지원)
          const loadedItems = (currentBrandSetting.officialChannels.items || []).map((item, idx) => {
            // 기본 아이템 구조에서 defaultImage 가져오기
            const defaultItem = this.officialChannels.items[idx];
            return {
              title: item.title || (defaultItem?.title || ''),
              defaultImage: item.defaultImage || (defaultItem?.defaultImage || null),
              fileList: item.image && item.image !== item.defaultImage
                ? [{ url: item.image, uid: `-channel-${idx}`, name: 'channel-icon' }]
                : [],
              link: item.link || '',
              isShow: item.isShow !== false,
            };
          });
          this.officialChannels = {
            ...this.officialChannels,
            ...currentBrandSetting.officialChannels,
            items: loadedItems.length > 0 ? loadedItems : this.officialChannels.items,
          };
        }
        // couponList 로드
        if (currentBrandSetting.couponList) {
          this.couponList = {
            ...this.couponList,
            ...currentBrandSetting.couponList,
            items: currentBrandSetting.couponList.items || [],
          };
        }
        if (currentBrandSetting.customSections) {
          const sections = (currentBrandSetting.customSections.sections || []).map((section, idx) => ({
            ...section,
            id: section.id || `customSection-${Date.now()}-${idx}`,
          }));
          this.customSections = {
            ...this.customSections,
            ...currentBrandSetting.customSections,
            sections: sections,
          };
        }
        // certificateList 로드
        if (currentBrandSetting.certificateList) {
          this.certificateList = {
            ...this.certificateList,
            ...currentBrandSetting.certificateList,
            items: currentBrandSetting.certificateList.items || [],
          };
        }
        this.companyName = currentBrandSetting.companyName;
        this.companyAddress = currentBrandSetting.companyAddress;
        this.companyBusinessNumber = currentBrandSetting.companyBusinessNumber;
        // 메인 버튼 로드 (기존 형식 호환)
        if (currentBrandSetting.mainButton) {
          this.mainButton = { ...this.mainButton, ...currentBrandSetting.mainButton };
        } else {
          // 기존 데이터 형식 호환
          this.mainButton.text = currentBrandSetting.mainButtonText || this.mainButton.text;
          this.mainButton.hexColor = currentBrandSetting.mainHexColor || this.mainButton.hexColor;
          this.mainButton.alpha = currentBrandSetting.mainAlpha ?? this.mainButton.alpha;
        }
        // 페이지 하단 버튼 로드 (없으면 메인 버튼 값 사용)
        if (currentBrandSetting.bottomButton) {
          this.bottomButton = { ...this.bottomButton, ...currentBrandSetting.bottomButton };
        } else {
          // 기존 데이터 형식 호환
          this.bottomButton.text = currentBrandSetting.bottomButtonText || currentBrandSetting.mainButtonText || this.bottomButton.text;
          this.bottomButton.hexColor = currentBrandSetting.bottomHexColor || currentBrandSetting.mainHexColor || this.bottomButton.hexColor;
          this.bottomButton.alpha = currentBrandSetting.bottomAlpha ?? currentBrandSetting.mainAlpha ?? this.bottomButton.alpha;
        }
        this.defaultImage = currentBrandSetting.defaultImage;
        this.companyImage = currentBrandSetting.companyImage;
        this.brandName = currentBrandSetting.brandName;
        // sectionOrder 로드 및 정규화
        this.sectionOrder = this.normalizeSectionOrder(currentBrandSetting.sectionOrder);
        // console.log(this.brandLogo);
        // console.log(this.mainBg);
        // console.log(this.imageList);
        // console.log(this.imageNewsList);
        // console.log(this.cardList);
        // console.log(this.newsList);
        // console.log(this.officialChannels);
        // console.log(this.customSections);
        // console.log(this.companyName);
        // console.log(this.companyAddress);
        // console.log(this.companyBusinessNumber);
        // console.log(this.mainButtonText);
        console.log(this.mainButton);
        console.log(this.bottomButton);
        // console.log(this.defaultImage);
        // console.log(this.companyImage);
        // console.log(this.brandName);
      }
    },
    async getOriginalFileFromUrl(url) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        
        // 파일명 추출 (URL에서 파일명을 추출하거나 기본값 사용)
        const fileName = url.split('/').pop() || 'logo.png';
        
        // File 객체 생성
        const file = new File([blob], fileName, {
          type: blob.type || 'image/png'
        });
        
        return file;
      } catch (error) {
        console.error('파일 변환 실패:', error);
        return null;
      }
    },
    // data URL을 File 객체로 변환하는 함수
    dataURLtoFile(dataURL, filename) {
      // data URL에서 MIME 타입과 base64 데이터 추출
      const arr = dataURL.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      
      // File 객체 생성
      return new File([u8arr], filename, { type: mime });
    },

    async getFileUrlForSaveBrandSettings(fileListObj){
      let imageUrl = '';
      // console.log('fileListObj');
      // console.log(fileListObj);
      if(fileListObj.image && typeof fileListObj.image === 'string'){
        "https://certilife.blob.core.windows.net/certilife/202506/file_1751116244671.png"
        if(fileListObj.image.includes('certilife.blob.core.windows.net')){
          imageUrl = fileListObj.image;
        }else{
          fileListObj.image.includes('/img/')
          // 2. 상대 경로나 절대 URL인 경우
          // console.log('상대 경로나 절대 URL인 경우');
          // console.log(fileListObj.image);
          const response = await fetch(fileListObj.image);
          const blob = await response.blob();
          const file = new File([blob], `${fileListObj.title}.png`, { type: blob.type });
          const formData = new FormData();
          formData.append('file', file);
          imageUrl = await this.uploadImage(formData);
          console.log(imageUrl);
        }
      }else if(fileListObj.image && typeof fileListObj.image === 'string' && fileListObj.image.includes('data:image')){
        // console.log('data:image');
        // console.log(fileListObj.image);
        const file = this.dataURLtoFile(fileListObj.image, `${fileListObj.title}.png`);
        const formData = new FormData();
        formData.append('file', file);
        imageUrl = await this.uploadImage(formData);
        console.log(imageUrl);
      }else if(fileListObj.uid){
        if(fileListObj.url.includes('certilife.blob.core.windows.net')){
          imageUrl = fileListObj.url;
        }else{
          // console.log('uid');
          // console.log(fileListObj.uid);
          // console.log(fileListObj.url);
          const file = await this.getOriginalFileFromUrl(fileListObj.url);
          console.log(file);
          const formData = new FormData();
          formData.append('file', file);
          imageUrl = await this.uploadImage(formData);
          console.log(imageUrl);
        }
      }else {
        // console.log('file');
        // console.log(fileListObj.file);
        const formData = new FormData();
        formData.append('file', fileListObj.file);
        imageUrl = await this.uploadImage(formData);
        console.log(imageUrl);
      }
      return imageUrl;
    },
    async changeDataFormatForSaveBrandSettings(){
      const companyId = jwtDecoder(getAccessToken());
      
      // brandLogo 처리
      const brandLogoFileList = await Promise.all(
        this.brandLogo.fileList.map(async (i) => {
          const imageUrl = await this.getFileUrlForSaveBrandSettings(i);
          return { url: imageUrl };
        })
      );

      // mainBg 처리
      const mainBgFileList = await Promise.all(
        this.mainBg.fileList.map(async (i) => {
          const imageUrl = await this.getFileUrlForSaveBrandSettings(i);
          return { url: imageUrl };
        })
      );

      // imageList 처리
      const imageListItems = await Promise.all(
        this.imageList.items.map(async (i) => {
          const fileList = await Promise.all(
            i.fileList.map(async (k) => {
              const imageUrl = await this.getFileUrlForSaveBrandSettings(k);
              return { url: imageUrl };
            })
          );
          return { ...i, fileList };
        })
      );

      // bigImageList 처리
      const bigImageListItems = await Promise.all(
        this.bigImageList.items.map(async (i) => {
          const fileList = await Promise.all(
            i.fileList.map(async (k) => {
              const imageUrl = await this.getFileUrlForSaveBrandSettings(k);
              return { url: imageUrl };
            })
          );
          return { ...i, fileList };
        })
      );

      // imageNewsList 처리
      const imageNewsListItems = await Promise.all(
        this.imageNewsList.items.map(async (i) => {
          const fileList = await Promise.all(
            i.fileList.map(async (k) => {
              const imageUrl = await this.getFileUrlForSaveBrandSettings(k);
              return { url: imageUrl };
            })
          );
          return { ...i, fileList };
        })
      );

      // certificateList 처리
      const certificateListItems = await Promise.all(
        this.certificateList.items.map(async (i) => {
          const fileList = await Promise.all(
            i.fileList.map(async (k) => {
              const imageUrl = await this.getFileUrlForSaveBrandSettings(k);
              return { url: imageUrl };
            })
          );
          return {
            maxSize: i.maxSize || 5,
            fileList,
            title: i.title,
            date: i.date,
            link: i.link
          };
        })
      );

      // couponList 처리
      const couponListItems = await Promise.all(
        this.couponList.items.map(async (i) => {
          const fileList = await Promise.all(
            i.fileList.map(async (k) => {
              const imageUrl = await this.getFileUrlForSaveBrandSettings(k);
              return { url: imageUrl };
            })
          );
          return {
            maxSize: i.maxSize || 5,
            fileList,
            title: i.title,
            link: i.link
          };
        })
      );

      // customSections 처리
      const customSectionsSections = await Promise.all(
        this.customSections.sections.map(async (i) => {
          const items = await Promise.all(
            i.items.map(async (j) => {
              const fileList = await Promise.all(
                j.fileList.map(async (k) => {
                  const imageUrl = await this.getFileUrlForSaveBrandSettings(k);
                  return { url: imageUrl };
                })
              );
              return { ...j, fileList };
            })
          );
          return { ...i, items };
        })
      );

      // officialChannels 처리 (업로드 이미지 지원)
      const officialChannelsItems = await Promise.all(
        this.officialChannels.items.map(async (i) => {
          // fileList에 업로드된 이미지가 있으면 사용, 없으면 null
          let image = null;
          if (i.fileList && i.fileList.length > 0) {
            image = await this.getFileUrlForSaveBrandSettings(i.fileList[0]);
          }
          return {
            title: i.title,
            image,
            link: i.link,
            isShow: i.isShow !== false
          };
        })
      );

      let imageNewsList = { ...this.imageNewsList, items: imageNewsListItems };
      delete imageNewsList.fileList;
      let imageList = { ...this.imageList, items: imageListItems };
      delete imageList.fileList;
      let bigImageList = { ...this.bigImageList, items: bigImageListItems };
      delete bigImageList.fileList;
      return {
        "companyId": companyId,
        "brandSetting": {
          "brandLogo": { ...this.brandLogo, fileList: brandLogoFileList },
          "mainBg": { ...this.mainBg, fileList: mainBgFileList },
          "companyImage": this.companyImage,
          "companyAddress": this.companyAddress,
          "companyName": this.companyName,
          "brandName": this.brandName,
          "companyBusinessNumber": this.companyBusinessNumber,
          "mainButton": this.mainButton,
          "bottomButton": this.bottomButton,
          "defaultImage": this.defaultImage,
          imageList,
          bigImageList,
          imageNewsList,
          "cardList": {...this.cardList,items:this.cardList.items.map(i=>{
            return {
              title: i.title,
              description: i.description,
              link: i.link
            }
          })},
          "newsList": {...this.newsList,items:this.newsList.items.map(i=>{
            return {
              title: i.title,
              description: i.description,
              link: i.link
            }
          })},
          "officialChannels": { ...this.officialChannels, items: officialChannelsItems },
          "customSections": { ...this.customSections, sections: customSectionsSections },
          "certificateList": { ...this.certificateList, items: certificateListItems },
          "couponList": { ...this.couponList, items: couponListItems },
          "sectionOrder": this.sectionOrder,
        }
      };
    },
    async saveBrandSettings(){
      console.log('saveBrandSettings');
      try {
        const obj = await this.changeDataFormatForSaveBrandSettings();
        console.log(obj);
        const response = await this.$apiInstance.post(`/brands/setting`, obj);
        console.log(response);
        if(response.status === 200 || response.status === 201) {
          oneBtnDialog('알림', '저장에 성공했습니다.', true);
        }else{
          oneBtnDialog('알림', '저장에 실패했습니다.', false);
        }
      } catch(error) {
        console.log(error);
        oneBtnDialog('알림', '저장에 실패했습니다.', false);
      }
    },
    searchAddress(){
      const thisObj = this;
      new daum.Postcode({
        oncomplete: (data) => {
          var addr = '';
          if (data.userSelectedType === 'R') {
            addr = data.roadAddress;
          } else {
            addr = data.jibunAddress;
          }
          console.log(addr)
          thisObj.companyAddress = addr;
        }
      }).open();
    },
    openLink(link){
      if(!link){
        message.error('링크가 없습니다.');
        return;
      }
      const windowFeatures = 'width=1024,height=800,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=yes,directories=no,status=yes';
      window.open(link, '_blank', windowFeatures);
    },
    setItemRef(el) {
      if (el) {
        this.sections.push(el);
      }
    },
    setSettingItemRef(el) {
      if (el) {
        this.settingSections.push(el);
      }
    },
    // SVG 및 WebP 파일 처리 도우미
    isSupportedImageType(fileType) {
      if (!fileType) return false;
      
      const supportedTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/svg+xml',
        'image/webp'
      ];
      
      return supportedTypes.includes(fileType);
    },
    
    // 업로드 전 파일 검증
    handleBeforeUpload(file, fileList, currentItem) {
      console.log('handleBeforeUpload');
      console.log('현재 파일:', file);
      console.log('현재 file-list:', fileList); 

      // 파일 존재 여부 확인
      if (!file) {
        message.error('유효하지 않은 파일입니다.');
        return false;
      }
      
      // 이미지 타입 확인
      const isImage = this.isSupportedImageType(file.type);
      
      if (!isImage) {
        message.error('지원되는 이미지 형식: JPG, PNG, GIF, SVG, WebP');
        return false;
      }
      
      // 파일 크기 확인
      const isLtMaxSize = file.size && file.size / 1024 / 1024 < currentItem.maxSize;
      if (!isLtMaxSize) {
        message.error(`이미지 크기는 ${currentItem.maxSize}MB 이하여야 합니다!`);
        return false;
      }
      return true;
    },

    
    // 이미지 변경 처리
    handleImageChange(info, currentItem) {
      // 정보가 없는 경우 처리하지 않음
      if (!info) return;
      
      try {
        // 파일 상태 로깅
        if (info.file) {
          console.log('info.file');
          console.log(info.file);
          console.log('ImageUpload handleImageChange:', info.file.status || '상태 없음');
        }
        
        // 파일 및 상태 확인
        const file = info.file;
        if (!file) return;
        
        // 파일 상태별 처리
        if (file.status === 'removed') {
          // 파일 제거 시 모든 상태 초기화
          currentItem.fileList = [];
          this.uploadStatus = '';
          this.fileUploadErrorMessage = '';
        } else if (file.status === 'error') {
          // 업로드 오류 처리
          this.uploadStatus = 'error';
          this.fileUploadErrorMessage = file.response?.message || '파일 업로드 실패';
          message.error('파일 업로드에 실패했습니다.');
        }else if (file.status === 'uploading') {
          console.log('uploading');
          console.log(currentItem);
          console.log('file');
          console.log(file);
          // 자동 업로드가 아닌 경우, 수동으로 파일 처리
          try {
            const reader = new FileReader();
            
            reader.onload = () => {
              console.log('reader.onload');
              const result = reader.result;
              if (typeof result === 'string') {
                
                // 파일 목록 설정
                const fileObj = {
                  file: file.originFileObj,
                  uid: file.uid || `-${Date.now()}`,
                  name: file.name || '이미지',
                  status: 'done',
                  url: result,
                  thumbUrl: result,
                  size: file.size || 0,
                  type: file.type || 'image/jpeg'
                };
                
                // 해당 file-list 업데이트
                if (currentItem) {
                  currentItem.fileList = [fileObj];
                }
              }
            };
            
            reader.onerror = () => {
              message.error('파일 읽기에 실패했습니다.');
            };
            
            // 파일 읽기 시작
            reader.readAsDataURL(file.originFileObj);
          } catch (error) {
            console.error('파일 처리 오류:', error);
            message.error('파일 처리에 실패했습니다.');
          }
        }
      } catch (error) {
        console.error('이미지 변경 처리 오류:', error);
      }
    },

    // 이미지 다운로드 처리
    handleDownload(file) {
      const url = file.url || file.thumbUrl;
      if (!url) {
        message.error('다운로드할 이미지가 없습니다.');
        return;
      }

      // 파일 이름 추출 또는 기본값 설정
      const fileName = file.name || `image_${Date.now()}.png`;

      // a 태그를 이용한 다운로드
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.target = '_blank';

      // blob URL이 아닌 외부 URL인 경우 fetch로 다운로드
      if (url.startsWith('http') && !url.startsWith('blob:')) {
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            link.href = blobUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch(() => {
            // CORS 문제 등으로 실패 시 새 탭에서 열기
            window.open(url, '_blank');
          });
      } else {
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    // 이미지 파일 삭제 처리
    handleRemoveFile(item) {
      if (item && item.fileList) {
        item.fileList = [];
      }
    },

    // Ant Design 커스텀 업로드 요청 처리
    customRequest({ file, onSuccess, onError, onProgress }) {
      console.log('customRequest');
    },
    addNewSubItem(obj){
      console.log('addNewSubItem');
      console.log(obj);
      obj.items.push({
        maxSize: 5,
        fileList: [],
        title: '',
        description: '',
        date: "",
        link: "",
      });
    },
    addNewChannelItem(){
      this.officialChannels.items.push({
        title: '새 채널',
        defaultImage: null,
        fileList: [],
        link: '',
      });
    },
    addNewSection(){
      console.log('addNewSection');
      const newId = `customSection-${Date.now()}`;
      // customSections.sections에 새 섹션 추가
      this.customSections.sections.push({
        id: newId,
        isShow: true,
        title: '커스텀 섹션',
        type: 'big-image-list', // 섹션 타입 (이미지 리스트, 카드 리스트, 뉴스 리스트 등)
        items: [
          {
            maxSize: 5, // 파일 크기 제한 (MB)
            fileList: [], // 이미지 파일 리스트
            title: '',
            description: '',
            date: '',
            link: '',
          }
        ]
      });
      // sectionOrder 맨 끝에 새 섹션 ID 추가
      this.sectionOrder.push(newId);
    },
    deleteItem(obj,index){
      obj.items.splice(index,1);
    },
    deleteItemForCustomSection(sectionId){
      // sectionOrder에서 제거
      const orderIndex = this.sectionOrder.indexOf(sectionId);
      if (orderIndex > -1) {
        this.sectionOrder.splice(orderIndex, 1);
      }
      // customSections.sections에서 제거
      const sectionIndex = this.customSections.sections.findIndex(s => s.id === sectionId);
      if (sectionIndex > -1) {
        this.customSections.sections.splice(sectionIndex, 1);
      }
    },
    updateHexColor() {
      this.mainButton.hexColor = this.rgbToHex(this.mainButton.color);
    },
    rgbToHex(rgb) {
      const result = rgb.match(/\d+/g);
      return result
        ? `#${((1 << 24) + (parseInt(result[0]) << 16) + (parseInt(result[1]) << 8) + parseInt(result[2]))
            .toString(16)
            .slice(1)
            .toUpperCase()}`
        : rgb;
    },
    hexToOpacity(rgba) {
      const result = rgba.match(/[\d.]+/g);
      console.log(result);
      if (result) {
        const a = result[3];
        if(a){
          return a;
        }else{
          return 1;
        }
      }else{
        return 1;
      }
    },
    handleSettingsScroll() {
      // 이미 스크롤 동기화 중이면 중복 실행 방지
      if (this.isScrollSyncing) return;

      // throttle: 100ms 간격으로 실행
      if (this.scrollThrottleTimer) return;
      this.scrollThrottleTimer = setTimeout(() => {
        this.scrollThrottleTimer = null;
      }, 100);

      const settingsSection = this.$refs.settingsSection;
      const previewSection = this.$refs.previewSection;

      if (!settingsSection || !previewSection) return;

      // 설정 패널에서 현재 보이는 섹션 찾기
      const settingsSections = settingsSection.querySelectorAll('[data-section-key]');
      const containerRect = settingsSection.getBoundingClientRect();
      const viewportTop = containerRect.top;
      const viewportMiddle = viewportTop + containerRect.height / 3;

      let currentSectionKey = null;
      let minDistance = Infinity;

      // 뷰포트 상단에 가장 가까운 섹션 찾기
      for (const section of settingsSections) {
        const rect = section.getBoundingClientRect();
        const distance = Math.abs(rect.top - viewportTop);

        // 섹션이 뷰포트 상단 근처에 있는지 확인
        if (rect.top <= viewportMiddle && rect.bottom > viewportTop) {
          if (distance < minDistance) {
            minDistance = distance;
            currentSectionKey = section.dataset.sectionKey;
          }
        }
      }

      if (currentSectionKey && this.lastSyncedSection !== currentSectionKey) {
        this.lastSyncedSection = currentSectionKey;

        // 미리보기 패널에서 해당 섹션 찾아서 스크롤
        const previewTarget = previewSection.querySelector(`[data-section-key="${currentSectionKey}"]`);
        if (previewTarget) {
          this.isScrollSyncing = true;
          previewTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });

          // 스크롤 애니메이션 완료 후 플래그 해제
          setTimeout(() => {
            this.isScrollSyncing = false;
          }, 500);
        }
      }
    }
  }
}
</script>

<style lang="scss">
.brand-settings-page{
  display: flex;
  flex-direction: column;
  height: 100%;
  p{
    margin:0;
  }
  header{
    height: 60px;
    border-bottom: 1px solid var(--Gray-3, #EBEEEF);
    background: var(--White, #FFF);
    display: flex;
    flex: none;
    .brand-header-left{
      display: flex;
      align-items: center;
      flex:2;
      gap: 10px;
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      padding-left: 20px;
      justify-content: center;
      i{
        margin-right: auto;
      }
      span{
        margin-right: auto;
      }
    }
    .brand-header-right{
      flex:1;
      display: flex;
      align-items: center;
      gap: 10px;
      margin-left: auto;
      padding-right: 20px;
      justify-content: flex-end;
    }
  }
  main{
    width:100%;
    height: calc(100vh - 60px);
    overflow: hidden;
    .brand-settings-container{
      width: 100%;
      height: 100%;
      display: flex;
      flex: 0 0 auto;
    }
    .brand-preview-section{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: #F3F5F7;
      overflow-y: auto;
      position: sticky;
      top: 0;
      &__inner{
        width:100%;
        max-width: 480px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        background-color: white;
        &__content{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          padding: 20px;
          background-color: white;
        }
      }
      .clickable-section{
        cursor: pointer;
        &:hover{
          transform: scale(1.01);
          filter: brightness(0.9);
        }
      }
      .main-bg{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .brand-header{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        .brand-logo{
          margin-top: -66px;
          width: 88px;
          height: 88px;
          border-radius: 88px;
          border: 1px solid rgba(0, 0, 0, 0.10);
          background: lightgray 50% / cover no-repeat;
          box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
          margin-bottom: 12px;
        }
        .brand-name{
          color: var(--color-text, #2F3337);
          text-align: center;
          font-family: "Pretendard";
          font-size: 20px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px; /* 120% */
          letter-spacing: -0.4px;
          margin:0;
        }
        .brand-address{
          color: var(--Gray-8, #8D939A);
          text-align: center;
          font-family: "Pretendard";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 171.429% */
          letter-spacing: -0.28px;
          margin-bottom: 24px;
        }

      }
      .view-more{
        margin-left: auto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 100%; /* 14px */
        letter-spacing: -0.28px;
        color: #8D939A;
      }
      .label-text{
        font-size: 18px;
        font-weight: 600;
        line-height: 24px; /* 133.333% */
        letter-spacing: -0.36px;
      }

      .ant-btn{
        border-radius: 8px;
        color: white;
        font-family: "Pretendard";
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 133.333% */
        letter-spacing: -0.36px;
        width: 100%;
        padding: 14px 16px;
        height: 52px;
        span{
          font-family: "Pretendard";
        }
        &.blue-button{
          background: #141E8C;
        }
      }

      .certificates{
        width: 100%;
        height: auto;
        display: flex;
        gap: 10px;
        overflow-x: auto;
        flex: none;
        .certificate{
          display: flex;
          width: 160px;
          height: 160px;
          align-items: flex-start;
          flex-direction: column;
          align-self: stretch;
          border-radius: 8px;
          flex: 1 0 0;
          &__inner{
            background: #D8DCF3;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            flex:  0 0 auto;
            img{
              width: auto;
              height: 160px;
            }
          }
          .certificate__title{
            color: var(--color-text, #2F3337);
            font-family: "Pretendard Variable";
            font-size: 17px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 141.176% */
            letter-spacing: -0.34px;
            margin-top: 10px;
          }
          .certificate__date{
            color: var(--Gray-8, #8D939A);
            font-family: "Pretendard Variable";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 22px; /* 157.143% */
            letter-spacing: -0.28px;
          }
        }
      }

      .coupon-list {
        width: 100%;
        height: auto;
        display: flex;
        gap: 10px;
        overflow-x: auto;
        flex: none;
        .coupon-item {
          display: flex;
          width: 120px;
          align-items: center;
          flex-direction: column;
          align-self: stretch;
          border-radius: 8px;
          flex: 0 0 auto;
          &__inner {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
            flex: 0 0 auto;
            img {
              width: 120px;
              height: auto;
              border-radius: 8px;
              border: 1px solid #EBEBEB;
            }
          }
          &__title {
            color: var(--color-text, #2F3337);
            font-family: "Pretendard Variable";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px;
            letter-spacing: -0.28px;
            margin: 4px 0 0 0;
            text-align: center;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .news-image{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
      .big-image-list{
        display: flex;
        flex-direction: column;
        width: 100%;
        .big-image-list__item{
          display: flex;
          flex-direction: column;
        }
      }
      .image-list{
        display: flex;
        flex-direction: row;
        align-items: stretch;
        gap: 12px;
        width: 100%;
        overflow-x: auto;
        padding-bottom: 8px;
        &::-webkit-scrollbar {
          height: 4px;
        }
        &::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 2px;
        }
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 2px;
        }
        .image-list__item{
          display: flex;
          flex-direction: column;
          flex: 0 0 auto;
          width: 140px;
          img{
            width: 140px;
            height: 140px;
            object-fit: contain;
            object-position: center;
            border-radius: 8px;
            border: 1px solid #EBEBEB;
            flex-shrink: 0;
            background-color: #F9F9F9;
          }
          .image-list__item__content{
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            padding: 8px 0;
            .image-list__item__title{
              color: var(--color-text, #2F3337);
              font-family: "Pretendard Variable";
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 20px;
              letter-spacing: -0.28px;
              word-break: keep-all;
            }
          }
        }
      }
      .smile-card-list{
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        .smile-card-list__item{
          display: flex;
          align-items: center;
          width: 100%;
          gap: 10px;
          border-radius: 8px;
          border: 1px solid var(--Gray-4, #DDE0E4);
          background: var(--White, #FFF);
          padding:16px;
          img{
            width: 48px;
            height: 48px;
            margin-right: 16px;
          }
          .smile-card-list__item__content{
            display: flex;
            flex-direction: column;
            gap: 5px;
            width: 100%;
            
            .smile-card-list__item__title{
              overflow: hidden;
              color: var(--color-text, #2F3337);
              text-overflow: ellipsis;
              font-family: "Pretendard Variable";
              font-size: 17px;
              font-style: normal;
              font-weight: 600;
              line-height: 24px; /* 141.176% */
              letter-spacing: -0.34px;
            }
            .smile-card-list__item__description{
              overflow: hidden;
              color: var(--Gray-8, #8D939A);
              text-overflow: ellipsis;
              font-family: "Pretendard Variable";
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px; /* 128.571% */
              letter-spacing: -0.28px;
            }
          }
        }
      }
      .news-list{
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        .news-list__item{
          display: flex;
          align-items: center;
          width: 100%;
          border-radius: 8px;
          background: var(--White, #FFF);
          img{
            width: 96px;
            height: 64px;
            flex: 0 0 auto;
          }
          .news-list__item__content{
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding-left: 16px;
            width: 100%;

            .news-list__item__title{
              overflow: hidden;
              color: var(--color-text, #2F3337);
              text-overflow: ellipsis;
              font-family: "Pretendard Variable";
              font-size: 17px;
              font-style: normal;
              font-weight: 600;
              line-height: 24px; /* 141.176% */
              letter-spacing: -0.34px;
              width: calc(100% - 16px);
            }
            .news-list__item__description{
              overflow: hidden;
              color: var(--Gray-8, #8D939A);
              text-overflow: ellipsis;
              font-family: "Pretendard Variable";
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px; /* 128.571% */
              letter-spacing: -0.28px;
              width: calc(100% - 16px);
            }
          }
        }
      }
      .channel-list{
        display: flex;
        gap: 10px;
        width: 100%;
        align-items: center;
        flex-wrap: wrap;
        img{
          width: 20px;
          height: 20px;
        }
        .channel-wrap{
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #F8FBFE;
          border-radius: 4px;
          padding:6px 12px;
          .channel-name{
            color: var(--Gray-10, #4B5158);
            text-align: center;
            font-family: "Pretendard Variable";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px; /* 128.571% */
            letter-spacing: -0.28px;
            margin-left: 8px;
          }
        }
      }

      .infomation-list{
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        .infomation-wrap{
          display: flex;
          gap: 10px;
          width: 100%;
          .infomation__label{
            color: var(--Gray-8, #8D939A);
            font-family: "Pretendard Variable";
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 133.333% */
            letter-spacing: -0.3px;
            flex: 1; /* 왼쪽 열의 넓이를 자동으로 조정 */
          }
          .infomation__text{
            color: var(--Gray-10, #4B5158);
            font-family: "Pretendard Variable";
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 133.333% */
            letter-spacing: -0.3px;
            flex: 2; /* 왼쪽 열의 넓이를 자동으로 조정 */
          }
        }
      }
    }
    .brand-settings-section{
      display: flex;
      flex-direction: column;
      width: 480px;
      height: 100%;
      flex: 0 0 auto;
      gap: 5px;
      border-left: 1px solid var(--Gray-3, #EBEEEF);
      background: var(--White, #FFF);
      overflow-y: auto;
      .ant-input-group{
        .ant-input-group-addon{
          background-color: white;
          border-right: 0;
          .vc-color-wrap{
            width: 30px !important;
            margin: 0 !important;
            border-radius: 5px;
          }
        }
        input{
          border-left: 0 !important;
        }
      }
    }
    .inner-section{
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 5px;
      padding: 36px;
      border-top: 1px solid var(--Gray-3, #EBEEEF);
    }
    .custom-section-item{
      background: transparent;
    }
    .custom-section-drag-handle{
      cursor: grab;
      &:active{
        cursor: grabbing;
      }
    }
    .custom-section-ghost{
      opacity: 0.5;
      background: #f0f0f0;
      border: 1px dashed #999;
      border-radius: 8px;
    }
    .custom-upload-item{
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
      .custom-upload-item__actions{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 8px;
        opacity: 0;
        transition: opacity 0.2s ease;
        i{
          color: white;
          font-size: 18px;
          cursor: pointer;
          padding: 8px;
          border-radius: 50%;
          transition: background 0.2s ease;
          &:hover{
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }
      &:hover{
        .custom-upload-item__actions{
          opacity: 1;
        }
      }
      &.channel-icon{
        width: 60px;
        height: 60px;
        img{
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
        .custom-upload-item__actions{
          border-radius: 50%;
          gap: 4px;
          i{
            font-size: 14px;
            padding: 4px;
          }
        }
      }
    }
    .channel-icon-upload{
      :deep(.ant-upload.ant-upload-select){
        width: 60px !important;
        height: 60px !important;
        border-radius: 50% !important;
        margin: 0 !important;
      }
    }
    .label-text{
      width: 100%;
      display: flex;
      align-items: center;
      color: var(--color-text, #2F3337);
      /* Body/MD/Medium */
      font-family: "Pretendard";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px; /* 157.143% */
      margin-top: 15px;
      &.big-size{
        font-weight: 700;
        line-height: 24px; /* 133.333% */
        font-size: 18px;;
        margin-bottom: 10px;
      }
      &.required::after {
        content: '';
        display: inline-block;
        width: 8px; /* 점의 크기 */
        height: 8px; /* 점의 크기 */
        background-color: #F55247; /* 점의 색상 */
        border-radius: 50%; /* 원형으로 만들기 */
        margin-left: 5px; /* 텍스트와의 간격 */
        vertical-align: middle; /* 텍스트와 수직 정렬 */
      }
    }
    .sub-text{
      color: var(--Gray-7, #ACB2B9);
      /* Body/SM/Regular */
      font-family: "Pretendard";
      font-size: 14px;
      font-style: normal;
      line-height: 22px; /* 157.143% */
      margin-top: -5px;
    }
    .deleteable-section{
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 5px;
      background:#F7F8F9;
      border: 1px solid #D1D6DB;
      border-radius: 8px;
      .deleteabled-section__header{
        display: flex;
        align-items: center;
        color: var(--color-text, #2F3337);
        font-family: "Pretendard";
        font-size: 14px;
        border-bottom: 1px solid #D1D6DB;
        padding: 12px 16px;
      }
      .deleteabled-section__content{
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 5px;
        padding: 0px 16px;
        padding-bottom: 16px;
      }
    }
    .section-order-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 100%;
    }
    .section-order-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      background: #F7F8F9;
      border: 1px solid #D1D6DB;
      border-radius: 8px;
      transition: all 0.2s ease;
      .drag-handle {
        cursor: grab;
        padding: 4px 8px;
        margin-right: 8px;
        color: #8D939A;
        &:hover {
          color: #141E8C;
        }
        &:active {
          cursor: grabbing;
        }
      }
      &__info {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
      }
      &__number {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        background: #141E8C;
        color: white;
        border-radius: 50%;
        font-size: 12px;
        font-weight: 600;
      }
      &__title {
        font-size: 14px;
        font-weight: 500;
        color: #2F3337;
      }
      &__status {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 4px;
        background: #EBEEEF;
        color: #8D939A;
        &.is-show {
          background: #E8F5E9;
          color: #2E7D32;
        }
      }
      &__actions {
        display: flex;
        gap: 4px;
        .ant-btn {
          padding: 4px 8px;
          min-width: 32px;
        }
      }
      &--ghost {
        opacity: 0.5;
        background: #E3E8F0;
        border: 2px dashed #141E8C;
      }
      &--drag {
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        border-color: #141E8C;
      }
    }
    .ant-btn{
      border:1px solid #D1D6DB !important;
    }
    .add-new-content-button{
      background-color: white;
      border: 1px solid #D1D6DB;
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
  }
  .ellipsis-text {
    display: block !important;
    white-space: nowrap; /* 텍스트를 한 줄로 표시 */
    overflow: hidden;    /* 넘치는 텍스트를 숨김 */
    text-overflow: ellipsis; /* 넘치는 부분을 ...으로 표시 */
  }
  .ellipsis-multiline {
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 표시할 줄 수 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ant-upload-list.ant-upload-list-picture-card .ant-upload-list-item-actions{
    display: flex;
    justify-content: center;
  }
}
</style>